const languageBtn = document.querySelector('.button-language');
const dropdown = document.querySelector('.language-dropdown');

languageBtn.addEventListener('click', (e) => {
	e.stopPropagation(); // stop bubbling
	dropdown.classList.toggle('active-language');
});

// click outside or on button again
document.addEventListener('click', (e) => {
	if (!languageBtn.contains(e.target) && !dropdown.contains(e.target)) {
		dropdown.classList.remove('active-language');
	}
});
